export const commonErr = {
    INNIT: 100,
    LOADING: 200,
    SUCCESS: 0,
    FAIL: -100,
}